import { TrashIcon } from 'lucide-react'
import { DefaultTooltip, InputGroup, InputGroupText, cn } from 'twyne-new.ui'

export const CONFIG_CONTROL_CLASS = 'min-w-0 flex-1 group-has-[.input-group-text-prepend]:rounded-l-none group-has-[.input-group-text-append]:rounded-r-none'

export function ConfigFieldRemoveButton({ label, onClick }) {
  return (
    <InputGroupText addonType="append" className="p-0">
      <button
        type="button"
        aria-label={label}
        className="flex h-full items-center px-2 twy-text-base-muted hover:twy-text-danger"
        onClick={onClick}
      >
        <TrashIcon size={14} />
      </button>
    </InputGroupText>
  )
}

export default function ConfigField({ label, icon: Icon, action, className, children }) {
  return (
    <InputGroup className={cn('w-72', className)}>
      <InputGroupText addonType="prepend">
        <DefaultTooltip content={label} triggerProps={{ asChild: true }}>
          <span className="flex items-center" aria-label={label}>
            <Icon size={14} className="twy-text-base-muted" />
          </span>
        </DefaultTooltip>
      </InputGroupText>
      {children}
      {action}
    </InputGroup>
  )
}
